<div class="d-flex text-center title-image">
  <div class="appbar-title col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
    >
    <p class="text-center text-white appbar-title-text" >IGNITE YOUR <span class="paragraph-span">SPIRIT</span></p>
  </div>
</div>
<!-- <ad-bar [data]="ad_data"></ad-bar> -->

  <div class="container padding-50-0 col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10" >
    <div class="divid-line bg-red" ></div>
    <div>
      <h6 class="cutting-text-2">
        IGNITE YOUR SPIRIT
      </h6>
    </div>
  </div>
  <div class="container">
  <div class="container text-center">
    <h6 style="margin: 4vw;">
      <span class="paragraph-span">-IGNITE YOUR</span> drive, dreams and <span class="paragraph-span">SPIRIT-</span><br>
      <span class="paragraph-span">NGK SPARK PLUG</span> has been a leader in manufacturing for 80 years.<br>
      Our desire is to live in a healthier and<br>
      more beautiful world where all our dreams can come true.<br> Everyday, we continue to ignite the passion in our
      hearts
      and spark new ideas<br> in our minds to focus on achieving our goals for the future.<br>
      Our mission is to continue to make the world a better place.<br><br>
      We will pursue future opportunities and<br> improve <span class="paragraph-span"> NGK SPARK PLUG</span>'s unique
      and advanced technologies.<br> <span class="paragraph-span">Our</span> diverse workforce will ignite our
      company<br>
      to create new products and to be a leader in innovation.<br> We will enhance our competitive advantage<br> by
      understanding and adapting to global changes.<br>
      Fueled and motivated by our own drive,<br> <span class="paragraph-span">NGK SPARK PLUG</span>
      will continue to <span class="paragraph-span">IGNITE YOUR SPIRIT</span>, instill passion in your hearts,<br>
      and deliver cutting edge solutions as a leading manufacturer in the world.

    </h6>
  </div>
</div>
<div class="container col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10">
  
  <div class="text-center container col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10" style="padding: 5% 0 8%;">
    <div class="box-shadow" style="padding: 5% 3%;border-radius: 10px;">
      <img class="company-profile-image col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" src="assets/params/images/demo/Group 158.png" alt="repaire icon"/>
    </div>
  </div>
  
</div>